//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  props: {},
  data () {
    return {
    }
  },
  created () { },
  mounted () {
  },
  methods: {
    gorule () {
      this.$router.push({ name: 'lalisaiRule' })
    }
  }
}
